import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "back-arrow",
  "use": "back-arrow-usage",
  "viewBox": "0 0 21 10",
  "content": "<symbol viewBox=\"0 0 21 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"back-arrow\"><path d=\"M0 5l5 5V6.428H20.71V3.572H5V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/back-arrow.svg
// module id = 1544
// module chunks = 0